import styled from 'styled-components';
export default styled.span.withConfig({
  displayName: "Trigger",
  componentId: "sc-11vx8mg-0"
})(["display:inline-flex;position:relative;"]);